import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useConnectShop = () => {
  return useMutation({
    mutationFn: async ({ shop }: { shop: string }) => await apiClient.connectShop(undefined, { queries: { shop } }),
  });
};
